import { useMediaQuery, useTheme } from '@mui/material'

interface IProps {
  pdfUrl: string
}

const VerifyOrderPdf = ({ pdfUrl }: IProps) => {
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div style={{ width: 'auto', height: isSm ? '550px' : '100%' }}>
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        title="PDF Viewer"
        style={{ border: 'none' }}
      />
    </div>
  )
}

export default VerifyOrderPdf
